import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Componente logo de PorCobrar
 * 
 * @component
 */
const Logo = () => {
  return (
    <Link className='topbar__logo logIn__logo__company' to='/app/contracts' />
  )
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js